import { apiDelete, apiGet, apiPost } from './client';

export type McpScope = 'mcp' | 'mcp:read' | 'mcp:write' | 'mcp:delete' | 'mcp:admin';

export interface McpToken {
  id: string;
  prefix: string;
  name: string;
  tenantId: string;
  scopes: McpScope[];
  createdBy: string;
  createdAt: string;
  expiresAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
  status: 'active' | 'expired' | 'revoked';
}

export interface CreatedMcpToken {
  token: McpToken;
  rawKey: string;
  endpoint: string;
  configurations: {
    codexToml: string;
    claudeCode: string;
    genericJson: string;
    smoke: string;
  };
}

export const mcpTokensApi = {
  list: () => apiGet<McpToken[]>('/api/mcp-tokens'),
  create: (data: { name: string; scopes: McpScope[]; expiresAt?: string }) =>
    apiPost<CreatedMcpToken>('/api/mcp-tokens', data),
  revoke: (id: string) => apiDelete<{ id: string; revoked: boolean }>(`/api/mcp-tokens/${id}`),
};
